import React, { useContext, useEffect, useState } from "react";
import "../../../../assets/css/user/deals/instantDeals.css";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import TpDealCard from "../../../../components/user/card/dealCard/TpDealCard";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const InstantDeals = () => {
  const navigate = useNavigate();

  const [instantDeals, setInstantDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  const { baseUrl } = useContext(AppContext);

  const fetchInstantDeals = () => {
    setLoading(true);

    axios
      .post(`${baseUrl}/customer/deals/fetchInstantDeals`)
      .then((response) => {
        setInstantDeals(response.data?.deals || []);
      })
      .catch((error) => {
        console.log(error);
        setInstantDeals([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchInstantDeals();
  }, []);

  return (
    <section className="instant-deals">
      {/* Section Header */}
      <div className="fd-header">
        <div>
          <h2 className="fd-title">Instant Deals</h2>
          <p className="fd-subtitle">
            Grab these deals before they expire
          </p>
        </div>

        <button
          className="fd-view-all"
          onClick={() => navigate("/deals?type=instant")}
        >
          View All <ArrowRight size={16} />
        </button>
      </div>

      <Container fluid className="fd-container">
        {loading ? (
          /* Loader */
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "250px" }}
          >
            <Spinner animation="border" variant="success" />
          </div>
        ) : (
          /* Deals */
          <Row className="fd-grid gx-4 gy-4">
            {(instantDeals || []).map((deal) => (
              <Col
                key={deal.id}
                xxl={3}
                xl={3}
                lg={4}
                md={6}
                sm={10}
                xs={12}
                className="fd-col"
              >
                <div className="fd-card-wrapper">
                  <TpDealCard deal={deal} />
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </section>
  );
};

export default InstantDeals;